import React, { useState, useRef } from "react";
import { Heading } from "../../../styles/component/style";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { HyperLink } from "../../../styles/component/style";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import useLoader from "../../../hooks/useLoader";
import AWSService from "../../../services/AWSService";
import { useSnackbar } from "notistack";
import {
  numberFormat,
  getErrorMessage,
  parseTimeStamp,
} from "../../../helpers/functions";
import CaseService from "../../../services/CaseService";
import DescriptionModal from "../DescriptionModal";
import AgentListModal from "../AgentListModal/AgentListDrawer";
import DocumentUploadModal from "../MultipleDocumentUploadModal";
import ViewNotesModal from "../../internal/ViewNotesModal";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ClaimItemsListModal from "../ClaimItemsListModal/index";
import AlertDialog from "../Alert";
import HearingModal from "../../internal/HearingDate/index";
import CounterClaimModal from "../ClaimItemsListModal/CounterClaim";
import HearingTimeline from "../HearingTimeLine/index";
import TrackingModal from "./component/TrackingModal";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
    border: "none",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
  },
  content: {
    margin: `0 !important`,
    "& .MuiExpansionPanelSummary-content.Mui-expanded": {
      margin: `0 !important`,
    },
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: `0 !important`,
  },
}));

const Index = ({
  caseDetails,
  setState,
  id,
  MTRef,
  isActionsDisabled = false,
  partyList = [],
  isViewAction = false,
  setTriggerCaseCall,
  docUploadModal,
  setDocUploadModal,
  setFields,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);
  const fileRef = useRef();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [file] = useState([]);
  const [modal, setModal] = useState();
  const [url, setUrl] = useState("");
  const [opendrawerClaim, setOpenDrawerClaim] = useState(false);
  const [viewNotes, setViewNotes] = useState(false);
  const [opendrawer, setOpenDrawer] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertData, setAlertData] = useState({});
  const [data, setData] = useState([]);
  const [openHearing, setOpenHearing] = useState(false);
  const [claimModal, setClaimModal] = useState(false);
  const [timelineModal, setTimelineModal] = useState({ state: false });
  const [trackingModal, setTrackingModal] = useState({ state: false });

  // async function s3Upload(file) {
  //   if (file) {
  //     try {
  //       setLoader({ state: true, message: `Uploading file ${file.name} ...` });
  //       const payload = {
  //         key: file.name
  //       };
  //       const s3Response = await AWSService.getS3URL(payload);
  //       if (s3Response.url) {
  //         const res = await AWSService.uploadToS3(s3Response.url, file);
  //         setUrl(res);
  //       }
  //     } catch (error) {
  //       const message = getErrorMessage(error);
  //       enqueueSnackbar(message, { variant: "error" });
  //     } finally {
  //       setLoader({ state: false });
  //     }
  //   }
  // }

  async function s3Upload(file) {
    if (file) {
      let len = file.length;
      let fileName = [];
      for (let i = 0; i < len; i++) {
        fileName.push(file[i]?.name);
      }
      try {
        setLoader({ state: true, message: `Uploading file...` });
        const payload = {
          key: fileName,
        };
        const s3Response = await AWSService.getS3URL(payload);
        if (s3Response.url) {
          const s3url = [];
          for (let i = 0; i < len; i++) {
            const res = await AWSService.uploadToS3(
              s3Response?.url[i],
              file[i],
            );
            s3url.push(res);
          }
          setUrl(s3url);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  /** Function to get the negotiation round Details */
  async function addDocumentForCase(data) {
    try {
      setLoader({ state: true, message: `Uploading document` });
      const documentDetails = data;
      const upload_response = await CaseService.caseAddDocument(
        { documentDetails },
        id,
      );
      enqueueSnackbar("Successfully Uploaded", { variant: "success" });
      if (MTRef?.current?.onSearchChange) {
        MTRef.current.onSearchChange("");
      }
      // setUrl("");
      setData([]);
      console.log(upload_response);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpenAlert(false);
      setDocUploadModal(false);
      setAlertData({});
    }
  }

  // const addNotes = async (value) => {
  //   try {
  //     setLoader({ state: true, message: "Adding notes..." });
  //     const payload = {
  //       content: value,
  //     };
  //     const res = await CaseService.addNotes(payload, id);
  //     if (res?.message) {
  //       enqueueSnackbar(res?.message, {
  //         variant: "success",
  //       });
  //     }
  //   } catch (error) {
  //     const message = getErrorMessage(error);
  //     enqueueSnackbar(message, {
  //       variant: "error",
  //     });
  //   } finally {
  //     setLoader({ state: false });
  //     // setAddnoteModal(false);
  //   }
  // };

  const respondentDisplay = () => {
    if (caseDetails?.respondentParty?.name)
      return caseDetails?.respondentParty?.name;
    if (caseDetails.respondentName) return caseDetails.respondentName;
    if (caseDetails?.respondentParties?.length)
      return caseDetails?.respondentParties[0]?.name;
    return "";
  };

  const respondentCount = partyList?.filter(
    (el) => el.partyRole === "respondent",
  )?.length;

  return (
    <>
      <ExpansionPanel className={classes.root} expanded={expanded}>
        <ExpansionPanelSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{ content: classes.content }}
        >
          <HeaderWrapper>
            <CaseTitleSection>
              <CaseTitle>{caseDetails.title}</CaseTitle>
            </CaseTitleSection>

            <RightActions>
              <ToggleButton
                onClick={() => setExpanded((e) => !e)}
                expanded={expanded}
                title={expanded ? "Collapse" : "Expand"}
              >
                {expanded ? "▲" : "▼"}
              </ToggleButton>
            </RightActions>
          </HeaderWrapper>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <InfoGridContainer>
            <GridRow>
              <InfoCard>
                <InfoLabel>Case ID</InfoLabel>
                <InfoValue>{caseDetails.id}</InfoValue>
              </InfoCard>

              {caseDetails?.resolutionKind === "arbitration" && (
                <InfoCard>
                  <InfoLabel>Contract Number</InfoLabel>
                  <InfoValue>
                    {caseDetails.loanAccountNo
                      ? caseDetails?.loanAccountNo
                      : "-"}
                  </InfoValue>
                </InfoCard>
              )}

              <InfoCard>
                <InfoLabel>Claimant</InfoLabel>
                <InfoValue>{caseDetails?.claimantParty?.name}</InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Respondent</InfoLabel>
                <InfoValue>
                  {respondentDisplay()}
                  {respondentCount - 1 > 0 && (
                    <MorePartiesLink
                      onClick={() =>
                        setOpenDrawer((a) => ({ ...a, state: true }))
                      }
                    >
                      +{respondentCount - 1} more
                    </MorePartiesLink>
                  )}
                </InfoValue>
              </InfoCard>
            </GridRow>

            <GridRow>
              <InfoCard>
                <InfoLabel>Claim Value</InfoLabel>
                <InfoValue>
                  {caseDetails.totalClaimValue
                    ? numberFormat(
                        parseFloat(caseDetails.totalClaimValue).toFixed(2),
                        caseDetails?.currencyUnit,
                      )
                    : "Non Monetary"}
                  {caseDetails?.resolutionKind === "mediation" &&
                  caseDetails?.caseItems?.length ? (
                    <MorePartiesLink
                      onClick={() =>
                        setOpenDrawerClaim((a) => ({ ...a, state: true }))
                      }
                    >
                      + View Items
                    </MorePartiesLink>
                  ) : (
                    ""
                  )}
                  {caseDetails?.resolutionKind === "arbitration" &&
                  caseDetails?.counterClaimValue !== 0 ? (
                    <MorePartiesLink onClick={() => setClaimModal(true)}>
                      + Counter Claim
                    </MorePartiesLink>
                  ) : null}
                </InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Filed on</InfoLabel>
                <InfoValue>
                  {caseDetails.created_at &&
                    moment(parseTimeStamp(caseDetails.created_at)).format(
                      "DD/MM/YYYY",
                    )}
                </InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Last Updated</InfoLabel>
                <InfoValue>
                  {caseDetails.updated_at &&
                    moment(parseTimeStamp(caseDetails.updated_at)).format(
                      "DD/MM/YYYY",
                    )}
                </InfoValue>
              </InfoCard>

              {caseDetails?.status !== "draft" && (
                <InfoCard>
                  <InfoLabel>Next Hearing</InfoLabel>
                  <HearingInfo
                    onClick={() =>
                      caseDetails?.hearingDatesSet?.length > 0 &&
                      setTimelineModal({
                        state: true,
                        data: caseDetails?.hearingDatesSet,
                      })
                    }
                    clickable={caseDetails?.hearingDatesSet?.length > 0}
                  >
                    {caseDetails?.nextHearingDate?.date?.length
                      ? caseDetails?.nextHearingDate?.time
                      : "N/A"}
                  </HearingInfo>
                  <UpdateLink
                    onClick={() => {
                      setOpenHearing((a) => ({ ...a, state: true }));
                      setTimelineModal({ state: false });
                    }}
                  >
                    Update
                  </UpdateLink>
                </InfoCard>
              )}
            </GridRow>

            <ActionButtonsContainer>
              <ActionGroup>
                <HyperLink onClick={() => setState(true)}>
                  Case Documents
                </HyperLink>

                {partyList.length > 0 && (
                  <HyperLink
                    onClick={() =>
                      setOpenDrawer((a) => ({ ...a, state: true }))
                    }
                  >
                    Agent Details
                  </HyperLink>
                )}

                {caseDetails?.resolutionKind !== "negotiation" && (
                  <HyperLink onClick={() => setViewNotes(true)}>
                    Scratch Pad
                  </HyperLink>
                )}

                {caseDetails?.resolutionKind === "arbitration" && (
                  <HyperLink onClick={() => setFields(true)}>
                    Case Details
                  </HyperLink>
                )}
                {caseDetails?.trackingNumbers?.length > 0 && (
                  <HyperLink
                    onClick={() =>
                      setTrackingModal({
                        state: true,
                        trackingData: caseDetails?.trackingNumbers,
                      })
                    }
                  >
                    Tracking Covers
                  </HyperLink>
                )}
              </ActionGroup>
            </ActionButtonsContainer>
          </InfoGridContainer>

          {/* Description Section */}
          <DescriptionSection>
            <Accordion className={classes.root}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <DescriptionHeading>
                  Case Description
                  {caseDetails?.caseTopic?.length > 0 && (
                    <KeywordsTag>
                      Keywords: {caseDetails.caseTopic.join(", ")}
                    </KeywordsTag>
                  )}
                </DescriptionHeading>
              </AccordionSummary>
              <DescriptionContent>
                {caseDetails?.description}
              </DescriptionContent>
            </Accordion>
          </DescriptionSection>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <AgentListModal {...{ opendrawer, setOpenDrawer, MTRef, partyList }} />
      <ClaimItemsListModal
        {...{
          opendrawerClaim,
          setOpenDrawerClaim,
          MTRef,
          displayAuthUrl: false,
        }}
        caseDetails={caseDetails}
      />
      <CounterClaimModal
        {...{
          claimModal,
          setClaimModal,
          MTRef,
          caseDetails,
        }}
      />
      <ViewNotesModal
        disabled={isActionsDisabled}
        modal={viewNotes}
        setModal={setViewNotes}
        type={
          caseDetails?.resolutionKind === "mediation"
            ? "Mediator"
            : "Arbitrator"
        }
        id={id}
      />
      <DescriptionModal
        {...{ modal, setModal }}
        description={caseDetails?.description}
      />
      <HearingModal
        {...{ openHearing, setOpenHearing, setTriggerCaseCall }}
        caseDetails={caseDetails}
      />
      {timelineModal?.state && (
        <HearingTimeline {...{ timelineModal, setTimelineModal }} />
      )}
      {trackingModal?.state && (
        <TrackingModal {...{ trackingModal, setTrackingModal }} />
      )}
      <DocumentUploadModal
        modal={docUploadModal}
        setModal={setDocUploadModal}
        handleUpload={s3Upload}
        file={file}
        fileRef={fileRef}
        url={url}
        setUrl={setUrl}
        data={data}
        setData={setData}
        resolutionKind={caseDetails?.resolutionKind}
        shareDefault={caseDetails?.resolutionKind}
        handleSuccess={(data) => {
          setOpenAlert(true);
          setAlertData({
            clickSecondarybtn: () => setOpenAlert(false),
            onDialogClose: () => setOpenAlert(false),
            primaryBtnText: "Ok",
            secondaryBtnText: "Cancel",
            desc:
              data && data.length === 1
                ? `${
                    data[0]["visibilityType"] === "all"
                      ? "Are you sure you want to share this document with all parties and Scrutiny Clerk?"
                      : data[0]["visibilityType"] === "me"
                        ? "Are you sure you want to keep this document private?"
                        : "Are you sure you want to share this document with Scrutiny Clerk?"
                  }`
                : "Are you sure you want to share this document?",
            // desc: `${
            //   checked && !checkedme
            //     ? "Are you sure you want to share this document with Case Manager?"
            //     : !checked && !checkedme
            //     ? "Are you sure you want to keep this document private?"
            //     : "Are you sure you want to share this document with all parties and Case Manager?"
            // }`,
            heading: `Alert`,
            clickPrimaryBtn: () => addDocumentForCase(data),
          });
        }}
        hasDocumentType={caseDetails?.resolutionKind === "arbitration"}
      />
      <AlertDialog isOpen={openAlert} {...{ ...alertData }} />
    </>
  );
};

export default Index;

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  width: 100%;
  gap: 16px;
`;

const CaseTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const CaseTitle = styled(Heading)`
  margin: 0 !important;
  font-size: 18px !important;
`;

// Right-aligned actions container
const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const ActionGroup = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 18px;
  align-items: center;
  flex-wrap: nowrap;
`;

const ToggleButton = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #293461;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #f7fafc;
  }
`;

const InfoGridContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const InfoCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #cbd5e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

const InfoLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #949ab0;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #293461;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MorePartiesLink = styled.button`
  background: none;
  border: none;
  color: #00838c;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  margin-top: 4px;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;

const HearingInfo = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  cursor: ${(p) => (p.clickable ? "pointer" : "default")};
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    color: ${(p) => (p.clickable ? "#00838c" : "#1a202c")};
  }
`;

const UpdateLink = styled.button`
  background: none;
  border: none;
  color: #00838c;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 0;
  transition: all 0.2s ease;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
  }
`;

const DescriptionSection = styled.div`
  padding: 0 24px 24px;
`;

const DescriptionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-left: 8px;
  font-weight: 600;
  color: #293461;
`;

const KeywordsTag = styled.span`
  background: #fef3c7;
  color: #92400e;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
`;

const DescriptionContent = styled.div`
  font-size: 14px;
  word-break: break-word;
  text-align: justify;
  color: #293461;
  font-family: ${theme.fonts.primaryFontSemiBold};
  padding: 16px;
  background: white;
  border-radius: 6px;
  border-left: 4px solid #00838c;
  max-height: 400px;
  overflow-y: auto;

  & strong,
  & bold {
    font-family: ${theme.fonts.primaryFontExtraBold};
    color: #1a202c;
  }

  & .ql-align-center {
    text-align: center;
  }
  & .ql-align-right {
    text-align: right;
  }
`;
